<script>
import baseList from '@/views/components/base/baseList.vue'
import { Tag, Button } from 'view-design'
import Vue from 'vue'
export default {
  extends: baseList,
  components: {
  },
  data() {
    return {
      table: {
        mname: 'work',
        key: 'id',
        url: {
          list: '/maintainer/maintainer/workOrder/list'
        },
        output: false,
      },
      actions: [
        { label: '入库记录', type: 'warning', onClick: this.toretrieval, auth: '' },
        { label: '出库记录', type: 'warning', onClick: this.tocheckout, auth: '' },
        { label: '维修记录', type: 'warning', onClick: this.tomainten, auth: '' },
        { label: '损坏记录', type: 'warning', onClick: this.todamage, auth: '' },
        { label: '报废记录', type: 'warning', onClick: this.toscrap, auth: '' },
      ],
      filters: [
      ],
      tableCols: [
        {
          title: '序号',
          type: 'index',
          width: 80,
          align: 'center',
        },
        {
          title: '资产名称',
          key: 'facilityName',
          minWidth: 100,
          align: 'left',
          render: (h, params) => {
            const row = params.row
            const text = row.facilityName
            return <span style={{ 'font-size': '14px' }}>{text}</span>
          },
        },
        {
          title: "问题描述",
          key: "descr",
          width: 220,
          align: "left",
          tooltip: "true",
        },
        {
          title: "工单类型",
          key: "typeName",
          minWidth: 120,
          align: "left",
          tooltip: "true",
        },
        {
          title: "报修时间",
          minWidth: 150,
          align: "center",
          key: "repairTime",
          sortable: true,
          render: (h, params) => {
            const row = params.row;
            const text = row.repairTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },
        {
          title: "所在科室",
          key: "department",
          minWidth: 100,
          align: "left",
          tooltip: "true",
        },
        {
          title: "具体位置",
          key: "address",
          minWidth: 100,
          align: "left",
          tooltip: "true",
        },
        {
          title: "报修人",
          minWidth: 100,
          align: "left",
          key: "repairBy",
          sortable: true,
          tooltip: "true",
        },
        {
          title: "报修电话",
          key: "repairPhone",
          minWidth: 130,
          align: "left",
          copy: true,
        },

        {
          title: "协同工单",
          key: "isSynergy",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.isSynergy === 0 ? "否" : "是";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },

        {
          title: "状态",
          key: "state",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.state === 3 ? "已完成" :row.state === 2 ? "处理中" :row.state === 1 ? "待处理" : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "报修来源",
          key: "repairSource",
          minWidth: 110,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
                row.repairSource === 1 && row.isFastOrder === 0
                    ? "扫码报修"
                    : row.repairSource === 1 && row.isFastOrder === 1
                        ? "移动报修"
                        : row.repairSource === 4
                            ? "电话报修"
                            : row.repairSource === 5 && row.isFastOrder === 0
                                ? "用户PC普通"
                                : row.repairSource === 5 && row.isFastOrder === 1
                                    ? "用户PC快速"
                            : row.repairSource === 3 && row.isFastOrder === 0
                                ? "后台设备报修"
                                : row.repairSource === 3 && row.isFastOrder === 1
                                    ? "后台科室报修"
                                    : row.repairSource === 2
                                        ? "维修员"
                                        : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "处理人",
          key: "maintainerName",
          minWidth: 100,
          align: "left",
        },
        {
          title: "操作",
          align: "center",
          width: 190,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              // let directives = [];
              let directives = [
                { name: "auth", value: "system/workOrder/info" },
              ];
              return (
                  <Button
                      {...{ directives }}
                      size="small"
                      onClick={() => this.toInfo(currentRow)}
                      type="default"
                      style={{
                        border:"none",
                        color: "#4991ff" }}
                  >
                    详情
                  </Button>
              );
            },
          ],
        },
      ],
    }
  },
  created() {
    let query = this.$route.query
    if(query.facilityNo) {
      this.query.facilityNo = query.facilityNo

    }
    this.facilityId=query.facilityId
    this.facilityNo=query.facilityNo
  },
  methods: {
//维修记录
    toInfo(val) {
      $utils.url.push({
        name: "workOrder_info_weixiu",
        query: { kv: val.id },
      });
    },
    //入库记录
    toretrieval(row = {}) {
      let facilityId = this.facilityId;
      let facilityNo = this.facilityNo
      $utils.url.push({
        name: "deviceRecordretrieval_list_weixiu",
        query: { facilityId: facilityId,facilityNo:facilityNo },
      });
    },
    //损坏记录
    todamage(row = {}) {
      let facilityId = this.facilityId;
      let facilityNo = this.facilityNo
      $utils.url.push({
        name: "deviceRecorddamage_list_weixiu",
        query: { facilityId: facilityId,facilityNo:facilityNo },
      });
    },
    //出库记录
    tocheckout(row = {}) {
      let facilityId = this.facilityId;
      let facilityNo = this.facilityNo
      $utils.url.push({
        name: "deviceRecordcheckout_list_weixiu",
        query: { facilityId: facilityId,facilityNo:facilityNo },
      });
    },
    //报废记录
    toscrap(row = {}) {
      let facilityId = this.facilityId;
      let facilityNo = this.facilityNo
      $utils.url.push({
        name: "deviceRecordscrap_list_weixiu",
        query: { facilityId: facilityId,facilityNo:facilityNo },
      });
    },
    //维修记录
    tomainten(row = {}) {
      let facilityId = this.facilityId
      let facilityNo = this.facilityNo
      $utils.url.push({ name: 'deviceMaintenance_list_weixiu', query: { facilityId: facilityId,facilityNo:facilityNo  } })
    },
  },
}
</script>
<style scoped></style>
